import dayjs from 'dayjs';
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import { Form, Schema, SelectPicker } from 'rsuite';
import credentialService from '../../../../../services/Internal/Credential/credential.service';
import { getCredStatus, getCredStatusReason, formatStatusReasonLabel } from '../../../../../services/Shared/codeTable.service';
import RedStar from '../../../../Shared/GenericComponents/RedStar';

function LsiCredentialForm(props) {
    const [formData, setFormData] = useState({});
    const [credStaus, setCredStaus] = useState([])
    const [credReason, setCredReason] = useState([])
    useEffect(() => {
        setFormData({
            ...props.credential,
            applicationDate: props.credential.applicationDate != null ? dayjs(props.credential.applicationDate).format('YYYY-MM-DD') : null,
            expirationDate: props.credential.expirationDate != null ? dayjs(props.credential.expirationDate).format('YYYY-MM-DD') : null,
            effectiveDate: props.credential.effectiveDate != null ? dayjs(props.credential.effectiveDate).format('YYYY-MM-DD') : null,
            reinstatementDate: props.credential.reinstatementDate != null ? dayjs(props.credential.reinstatementDate).format('YYYY-MM-DD') : null,
            firstIssuanceDate: props.credential.firstIssuanceDate != null ? dayjs(props.credential.firstIssuanceDate).format('YYYY-MM-DD') : null,
            dateMod: props.credential.dateMod != null ? dayjs(props.credential.dateMod).format('YYYY-MM-DD') : null,
            statusLabel: props.credential.status?.status,
            statusReasonLabel: formatStatusReasonLabel(props.credential.statusReason?.statusReason, props.credential.status?.status),
            status: props.credential.status,
            statusReason: props.credential.statusReason,
        });

        getCredStatus().then(setCredStaus);
        getCredStatusReason(props.credential.status?.id, props.credential.status?.status).then(setCredReason);
    }, [props.credential])

    const { ObjectType } = Schema.Types;
    const model = Schema.Model({
        statusReason: ObjectType().isRequired('This field is required.'),
        status: ObjectType().isRequired('This field is required.'),

    })

    const handleCredentialStatusChange = (val) => {
        setFormData({ ...formData, status: val, statusReason: null })
        getCredStatusReason(val?.id, val?.status).then(setCredReason);
    }

    const submitForm = (validation, event) => {
        if (validation) {
            var dataToTransmit = {
                ...formData,
                expirationDate: formData.expirationDate == '' ? null : formData.expirationDate,
                effectiveDate: formData.effectiveDate == '' ? null : formData.effectiveDate,
                reinstatementDate: formData.reinstatementDate == '' ? null : formData.reinstatementDate,
            }
            credentialService.updateLsiCredential(dataToTransmit).then((response) => {
                props.saveSuccess(response.data)
            });
        }
    }
    return (
        <Form id={props.formId} fluid model={model} formValue={formData} onChange={setFormData} onSubmit={submitForm} >
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Credential #</b></Form.ControlLabel>
                    <Form.Control name="formattedLicenseNumber" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Status</b> {props.editMode && <RedStar />}</Form.ControlLabel>
                    {props.editMode ?
                        <Form.Control
                            name="status"
                            block
                            data={credStaus}
                            accepter={SelectPicker}
                            searchable={false}
                            placeholder="Select Status"
                            onChange={handleCredentialStatusChange} /> :
                        <Form.Control name="statusLabel" block disabled />
                    }
                </Col>
                <Col>
                    <Form.ControlLabel><b>Credential Reason</b> {props.editMode && <RedStar />}</Form.ControlLabel>
                    {props.editMode ?
                        <Form.Control
                            name="statusReason"
                            block
                            data={credReason}
                            accepter={SelectPicker}
                            searchable={false}
                            readOnly={!formData.status}
                            placeholder="Select Status Reason" /> :
                        <Form.Control name="statusReasonLabel" block disabled />
                    }
                </Col>

            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>First Issuance Date</b></Form.ControlLabel>
                    <Form.Control name="firstIssuanceDate" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Effective Date</b></Form.ControlLabel>
                    <Form.Control
                        name="effectiveDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col><Col>
                    <Form.ControlLabel><b>Expiration Date</b></Form.ControlLabel>
                    <Form.Control
                        name="expirationDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
            </Row>
            <Row className="mb-3">
                <Col>
                    <Form.ControlLabel><b>Application Date</b></Form.ControlLabel>
                    <Form.Control name="applicationDate" type={props.editMode ? "date" : 'text'} disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Application Type</b></Form.ControlLabel>
                    <Form.Control name="applicationType" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Reinstatement Date</b></Form.ControlLabel>
                    <Form.Control
                        name="reinstatementDate"
                        type={props.editMode ? "date" : 'text'}
                        disabled={!props.editMode} />
                </Col>
            </Row>
            <Row>
                <Col>
                    <Form.ControlLabel><b>Licensed By</b></Form.ControlLabel>
                    <Form.Control name="approvedBy" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Last Updated By</b></Form.ControlLabel>
                    <Form.Control name="userMod" disabled />
                </Col>
                <Col>
                    <Form.ControlLabel><b>Date of Last Activity</b></Form.ControlLabel>
                    <Form.Control name="dateMod" disabled />
                </Col>
            </Row>
        </Form>
    );
}

export default LsiCredentialForm;